Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLink = void 0;
var _styles = require("../../../../../styles");
var useLink = exports.useLink = function useLink() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    fontSemiBold = _STYLES$useStyles.fontSemiBold;
  var link = {
    label: Object.assign({}, fontSemiBold, {
      backgroundColor: colors.transparent,
      color: colors.text,
      textDecorationLine: 'underline'
    }),
    small: {
      fontSize: _styles.STYLES.fontSize.s,
      lineHeight: _styles.STYLES.lineHeight.s
    },
    normal: {
      fontSize: _styles.STYLES.fontSize.normal,
      lineHeight: _styles.STYLES.lineHeight.normal
    },
    large: {
      fontSize: _styles.STYLES.fontSize.l,
      lineHeight: _styles.STYLES.lineHeight.l
    },
    focused: {
      outlineOffset: (0, _styles.getREM)(0.25),
      borderRadius: (0, _styles.getREM)(0.25)
    },
    pointerOver: {
      textDecorationLine: 'underline'
    }
  };
  return {
    link: link
  };
};